import React, { useCallback, useEffect } from 'react';
import { connect, FormikContextType } from 'formik';
import styled, { useTheme } from 'styled-components';

import Btn from '../../../buttons/Btn';
import { FormState } from './enums';
import { SCREENS_TRANSITIONS } from './constants';
import { ReviewFormValues } from '../types';
import arrowIcon from '../../../../images/icon-forward.svg';
import { Footnote } from '../Footnote';
import { DrivingSchoolsType } from '../constants';
import { TEXT_COLOR, NOTES_COLOR } from '../../../../theme';

const Form = styled.form``;

const NextButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
`;

const NextButtonTitle = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${TEXT_COLOR};
`;

const NextButtonCount = styled.span`
  font-size: 14px;
  font-weight: normal;
  line-height: 1.29;
  letter-spacing: -0.1px;
  text-align: right;
  color: ${NOTES_COLOR};
`;

const IconNext = styled.img`
  width: 16px;
  height: 16px;
`;

type FormProps = {
  reviewTextRef: React.RefObject<HTMLTextAreaElement>,
  firstName: string,
  examCenterTitle: string,
  examCenterLogo: string,
  activeScreen: FormState,
  isLastScreen: boolean,
  setNextScreen(val: FormState): void;
};

type FormikProps = {
  formik: FormikContextType<ReviewFormValues>;
};

const FormComponent = (props: FormProps & FormikProps) => {
  const {
    formik, activeScreen, setNextScreen, isLastScreen, ...restProps
  } = props;
  const {
    values, isSubmitting, handleSubmit,
  } = formik;

  useEffect(() => {
    let nextScreen: FormState;
    if (typeof SCREENS_TRANSITIONS[activeScreen].next === 'function') {
      nextScreen = SCREENS_TRANSITIONS[activeScreen].next(values.drivingSchoolType, values.helpSearchSchool);
    } else {
      nextScreen = SCREENS_TRANSITIONS[activeScreen].next;
    }
    setNextScreen(nextScreen);
  }, [activeScreen, values.helpSearchSchool, values.drivingSchoolType]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeScreen]);

  const theme = useTheme();

  const Screen = SCREENS_TRANSITIONS[activeScreen].node;

  const getTotalSteps = useCallback(() => (
    activeScreen === FormState.StudyType
    && values.helpSearchSchool === '1'
    && values.drivingSchoolType !== DrivingSchoolsType.TRADITIONAL
      ? 4
      : 3
  ), [activeScreen, values.helpSearchSchool, values.drivingSchoolType]);

  return (
    <Form onSubmit={handleSubmit}>
      <Screen {...formik} {...restProps} />
      {(activeScreen !== FormState.StudyType || !!values.drivingSchoolType) && (
        <Btn
          color={theme.buttonColor}
          textColor={theme.buttonTextColor}
          type="submit"
          text={isLastScreen ? "Publier l'avis" : (
            <NextButton>
              <NextButtonTitle>Étape suivante</NextButtonTitle>
              <NextButtonCount>{`${SCREENS_TRANSITIONS[activeScreen].step} sur ${getTotalSteps()}`}</NextButtonCount>
              <IconNext src={arrowIcon} />
            </NextButton>
          )}
          isLoading={isSubmitting}
          outlined={!isLastScreen}
          block
        />
      )}
      {isLastScreen && <Footnote />}
    </Form>
  );
};

const SmallResolutionForm: React.ComponentType<FormProps> = connect(FormComponent);

export { SmallResolutionForm };
